const Languages = ['fr','en']
export default Languages